module.exports = __webpack_public_path__ + "img/no_calendar_pricing.be4e2395.svg";